import { render } from "./FrotaAlertasPorServicoChart.vue?vue&type=template&id=e137c1aa&scoped=true"
import script from "./FrotaAlertasPorServicoChart.vue?vue&type=script&lang=js"
export * from "./FrotaAlertasPorServicoChart.vue?vue&type=script&lang=js"

import "./FrotaAlertasPorServicoChart.vue?vue&type=style&index=0&id=e137c1aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e137c1aa"]])

export default __exports__